import React, { useState } from "react";
import { Box, CssBaseline, Grid } from "@mui/material";

import { FilterSection, SearchBar } from "../../components/components";
import Header from "../../../../../common/Header";
import GeneralAdminSidebar from "../../../../../common/GeneralAdminSidebar";
import { mainLayoutStyles } from "../../../../../constants";
import FilterModalComponent from "../../../../../common/FilterModalComponent";

const GAReportsContainer = () => {
  const [filterModal, setFilterModal] = useState(false);
  const [selected, setSelected] = useState([]);
  const [filterOptions, setFilterOptions] = useState([]);

  const handleFilterModalOpen = () => {
    setFilterModal(true);
  };
  const handleFilterModalClose = () => {
    setFilterModal(false);
  };

  const resetFilter = async () => {
    setFilterOptions([]);
  };

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <Header mainTitle={"Reports"} bgColor="#fff" />
      <GeneralAdminSidebar />
      <Grid container style={{ ...mainLayoutStyles, background: "#fff" }}>
        <Grid container direction={"column"}>
          <FilterSection
            handleFilterModalOpen={handleFilterModalOpen}
            filterOptions={filterOptions}
          />
          <SearchBar selected={selected} setSelected={setSelected} />
          {/*
          <Scrollbars
            style={scrollbar}
            autoHide={true}
            ref={scrollbarsRef} // Assign the ref to Scrollbars instance
            renderThumbVertical={({ style, ...props }) => (
              <div
                {...props}
                style={{
                  ...style,
                  ...scrollbarprops,
                }}
              />
            )}
          >
            <ReportsTable selected={selected} setSelected={setSelected} />
          </Scrollbars>
            */}
        </Grid>
      </Grid>
      <FilterModalComponent
        modalOpen={filterModal}
        handleClose={handleFilterModalClose}
        resetFilter={resetFilter}
        handleFilter={handleFilterModalClose}
        data={[
          {
            mainOptions: filterOptions,
            setMainOptions: setFilterOptions,
            type: "text",
            title: "Status",
            currentOptions: [
              { label: "All", selected: true },
              { label: "accepted", selected: false },
              { label: "pending", selected: false },
              { label: "declined", selected: false },
            ],
          },
        ]}
      />
    </Box>
  );
};

export default GAReportsContainer;
